import React from 'react';
import styles from '../css/ReportsTable.module.css';

const ReportsTable = ({ columns, data, striped = true }) => {
  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            {columns.map((column, index) => {
              // Skip rendering headers for spanned columns
              if (column.accessor === 'rxItems2' || column.accessor === 'avg2') return null;
              return (
                <th 
                  key={index} 
                  className={styles.headerCell}
                  colSpan={column.header === '#RX Items' || column.header === '(--Average--)' ? 2 : undefined}
                >
                  {column.header}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => {
            const isReversalAccepted = row.payDue === 'Reversal Accepted';
            const payDueColumnIndex = columns.findIndex(col => col.accessor === 'payDue');
            
            return (
              <tr 
                key={rowIndex} 
                className={[
                  styles.dataRow,
                  striped && rowIndex % 2 === 1 ? styles.stripedRow : '',
                  row?.isTotal ? styles.totalRow : '',
                  row?.isHighlight ? styles.highlightRow : '',
                  isReversalAccepted ? styles.reversalRow : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {isReversalAccepted ? (
                  <>
                    {/* Render columns before Pay Due normally */}
                    {columns.slice(0, payDueColumnIndex).map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className={[
                          styles.dataCell,
                          row?.isTotal ? styles.totalCell : '',
                          colIndex === 0 && row?.isTotal ? styles.totalLabelCell : '',
                        ]
                          .filter(Boolean)
                          .join(' ')}
                      >
                        {column.render ? column.render(row[column.accessor], row) : row[column.accessor]}
                      </td>
                    ))}
                    {/* Single spanning cell for Pay Due and all remaining columns */}
                    <td 
                      className={[
                        styles.dataCell,
                        styles.reversalCell,
                      ].filter(Boolean).join(' ')}
                      colSpan={columns.length - payDueColumnIndex}
                    >
                      {row.payDue}
                    </td>
                  </>
                ) : (
                  columns.map((column, colIndex) => (
                    <td
                      key={colIndex}
                      className={[
                        styles.dataCell,
                        row?.isTotal ? styles.totalCell : '',
                        colIndex === 0 && row?.isTotal ? styles.totalLabelCell : '',
                      ]
                        .filter(Boolean)
                        .join(' ')}
                    >
                      {column.render ? column.render(row[column.accessor], row) : row[column.accessor]}
                    </td>
                  ))
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ReportsTable;
